<footer class="footer">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-6">
        <div class="fs-6 footer-links d-none d-md-block text-black">
          <script>document.write(new Date().getFullYear())</script> © ISPRA Istituto Superiore per la Protezione e la Ricerca Ambientale<br>
          Via Brancati, 48 - 00144 Roma (I) - Codice fiscale e Partita Iva 10125211002<br>
          Indirizzo di Posta Elettronica Certificata (PEC) istituzionale <a href="mailto:protocollo.ispra@ispra.legalmail.it" target="_blank">protocollo.ispra@ispra.legalmail.it</a><br>
        </div>

      </div>
      <div class="col-md-6">
        <div class="text-md-end footer-links d-none d-md-block">
          <a *ngIf="config.applicationSettings.linkAccessibilita" href="{{config.applicationSettings.linkAccessibilita}}" target="_blank">Accessibilità {{config.linkAccessibilita}}</a>
          <a *ngIf="config.applicationSettings.linkPrivacy" href="{{config.applicationSettings.linkPrivacy}}" target="_blank">Privacy</a>
          <a *ngIf="config.applicationSettings.linkNoteLegali" href="{{config.applicationSettings.linkNoteLegali}}" target="_blank">Note Legali</a>
        </div>
      </div>
    </div>
  </div>
</footer>
